import React from "react";
import { Button, Result, Row } from "antd";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <Row justify={"center"} style={{ marginBottom: "80px" }}>
      <Result
        status="404"
        title="Page Not Found"
        extra={
          <Link to="/" replace>
            <Button type="primary">Back to Home</Button>
          </Link>
        }
      />
    </Row>
  );
};

export default NotFound;
